"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getColorFromSpecification_1 = __importDefault(require("../../shared/getColorFromSpecification"));
const getControlsColorSpecificationByString_1 = __importDefault(require("../../shared/getControlsColorSpecificationByString"));
const valueIsControlsColorSpecification_1 = __importDefault(require("../../typeAssertions/valueIsControlsColorSpecification"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const valueIsUndefined_1 = __importDefault(require("../../typeAssertions/valueIsUndefined"));
const callableSetPaletteColors = ({ entryVars: { primaryColor, secondaryColor }, executeProcesses, callbacks, functionId, processor, }) => {
    var _a, _b;
    if (!(0, valueIsString_1.default)(primaryColor)) {
        executeProcesses(functionId, callbacks.onError, 'Primary color is not valid');
        return;
    }
    if (!(0, valueIsString_1.default)(secondaryColor)) {
        executeProcesses(functionId, callbacks.onError, 'Secondary color is not valid');
        return;
    }
    const shadeBases = (_b = (_a = processor.root.getBuildOrders()) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.shadeBases;
    const primarySpecification = (0, getControlsColorSpecificationByString_1.default)(primaryColor);
    const secondarySpecification = (0, getControlsColorSpecificationByString_1.default)(secondaryColor);
    if (!(0, valueIsControlsColorSpecification_1.default)(primarySpecification)
        || !(0, valueIsControlsColorSpecification_1.default)(secondarySpecification)) {
        executeProcesses(functionId, callbacks.onError, 'Colors is not valid');
        return;
    }
    let primary = (0, getColorFromSpecification_1.default)(primarySpecification, shadeBases);
    let secondary = (0, getColorFromSpecification_1.default)(secondarySpecification, shadeBases);
    if ((0, valueIsUndefined_1.default)(primary)) {
        primary = primaryColor;
    }
    if ((0, valueIsUndefined_1.default)(secondary)) {
        secondary = secondaryColor;
    }
    processor.root.updateApplicationPaletteColors({
        primary,
        secondary,
        black: 'black',
    });
    executeProcesses(functionId, callbacks.onSuccess, {
        primaryColor,
        secondaryColor,
    });
};
exports.default = callableSetPaletteColors;
